import React, { useEffect, useState, useMemo } from 'react'
import $ from 'jquery'
import classNames from 'classnames'
import { Button } from 'react-bootstrap'
import Icon, { ilsMoon, ilsSun } from '../ui/Icon'

const ThemeProvider = ({
    theme = '',
    floatSwitch = false,
    children
}) => {
    const localTheme = localStorage.getItem('theme');
    const fallbackTheme = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'default';
    const themeChain = theme || localTheme || fallbackTheme;
    const [currentTheme, setCurrentTheme] = useState(themeChain);

    useEffect(() => {
        changeTheme(themeChain);
        setCurrentTheme(themeChain);
    }, [themeChain]);
    
    return (
        <ThemeContext.Provider value={currentTheme}>
            {children}
            {floatSwitch && (
                <ThemeFloatSwitch onThemeChange={setCurrentTheme} />
            )}
        </ThemeContext.Provider>
    )
}

/**
 * Theme Context
 */

export const ThemeContext = React.createContext("default");

/**
 * Helpers
 */
const changeTheme = (theme) => {
    const $body = $('body');
    const localTheme = localStorage.getItem('theme');

    if (
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches &&
        !localTheme
    ) {
        $body.addClass(`theme--dark`);
        localStorage.setItem('theme', 'dark');
    } else {
        if ($body.hasClass('theme--default')) {
            $body.removeClass('theme--default');
        } else if ($body.hasClass('theme--dark')) {
            $body.removeClass('theme--dark');
        }

        $body.addClass(`theme--${theme}`);
        localStorage.setItem('theme', theme);
    }
}

export const isDarkMode = localStorage.getItem('theme') === 'dark';

/**
 * Switch Components
 */

export const ThemeSwitch = ({
    onThemeChange = console.log
}) => {
    const localTheme = localStorage.getItem('theme');
    const [isDarkMode] = useState(
        (localTheme === 'dark') ||
        (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && !localTheme)
    );

    const handleThemeChange = e => {
        let isDark = e.target.checked;
        const theme = isDark ? 'dark' : 'default';
        localStorage.setItem('theme', theme);
        onThemeChange(theme);
    }

    return (
        <div className="toggle-mode">
            <label className="switch material-switch with-icon">
                <input type="checkbox" onChange={handleThemeChange} defaultChecked={isDarkMode} />
                <span className="toggle-slider round"></span>
            </label>
        </div>
    )
}

export const ThemeFloatSwitch = ({
    onThemeChange = console.log
}) => {
    const localTheme = localStorage.getItem('theme');
    const [isDarkMode] = useState(
        (localTheme === 'dark') ||
        (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && !localTheme)
    );

    const [currentTheme, setCurrentTheme] = useState(isDarkMode ? 'dark' : 'default')

    const handleThemeChange = theme => {        
        onThemeChange(theme);
        localStorage.setItem('theme', theme);
        setCurrentTheme(theme);
    }

    const toggleTheme = () => {
        if (currentTheme === 'dark') {
            handleThemeChange('default');
        } else {
            handleThemeChange('dark');
        }
    }

    return (
        <Button
            onClick={() => toggleTheme()}
            variant={currentTheme === 'dark' ? 'light' : 'dark'}
            className={classNames("theme-float-switch", currentTheme)}
        >
            <Icon svg={currentTheme === 'dark' ? ilsSun : ilsMoon} />
        </Button>
    )
}

export default ThemeProvider
